module.exports = __webpack_public_path__ + "img/gzhCode.e89e6d53.png";